import { Box, Typography } from "@mui/material";

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  descrption: string;
  callToAction?: React.ReactNode;
}

export default function CommonEmptyState({
  icon,
  title,
  descrption,
  callToAction,
}: EmptyStateProps) {
  return (
    <Box
      sx={(th) => ({
        backgroundColor: th.nawy.colors.semantic.layer.primary,
        p: th.nawy.spacing.md,
        display: "flex",
        flexDirection: "column",
        gap: th.nawy.spacing.sm,
        borderRadius: th.nawy.radius.xl,
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      })}
    >
      {icon}
      <Box
        sx={(th) => ({
          display: "flex",
          flexDirection: "column",
          gap: th.nawy.spacing.xs,
          alignItems: "center",
        })}
      >
        <Typography
          sx={(th) => th.nawy.typography.english.variants.headline.xs}
        >
          {title}
        </Typography>
        <Typography
          sx={(th) => th.nawy.typography.english.variants.body.md.regular}
        >
          {descrption}
        </Typography>
      </Box>
      {callToAction}
    </Box>
  );
}
